// extracted by mini-css-extract-plugin
export default {"title":"style_title__nISLu","subtitle":"style_subtitle__+54C0"};